<template>
  <slot
    :number="number"
    :formated-number="formatedNumber"
  >
    {{ formatedNumber }}
  </slot>
</template>

<script setup>
import { computed } from 'vue'
import { useCurrencyStore } from '@/stores/CurrencyStore'

const { number } = defineProps({
  number: { type: [Number, String], default: 0 }
})

const { getFormatedNumber } = useCurrencyStore()

const formatedNumber = computed(() => getFormatedNumber(parseFloat(number)))
</script>
